import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import WelcomeName from "./WelcomeName";
import SignInSignOutButton from "./SignInSignOutButton";
import HomeButton from "./HomeButton";
import { Link as RouterLink , useLocation } from "react-router-dom";




const NavBar = () => {
    const location = useLocation();
    
    const versionInfo = {
        version: "v1.4",
        releaseDate: "2026-01-06",
        changes: [
            "🆕 SRT Generator (AI ondertiteling)",
            "   • OpenAI Whisper transcriptie",
            "   • GPT-4o correctie & feedback",
            "   • Download origineel + gecorrigeerd",
            "✅ Extra dag vóór/na draaidag (📅-1 / 📅+1)",
            "✅ Weergavenaam aanpasbaar + auto-save",
            "✅ Draaidag info met Callsheet links",
            "✅ Verbeterde kalender & responsive design"
        ]
    };
    
    const tooltipContent = (
        <div style={{ textAlign: 'left', maxWidth: '300px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                {versionInfo.version} - {versionInfo.releaseDate}
            </div>
            <div style={{ fontSize: '0.8rem' }}>
                <div style={{ marginBottom: '4px', fontWeight: 'bold' }}>Laatste wijzigingen:</div>
                {versionInfo.changes.map((change, index) => (
                    <div key={index} style={{ marginBottom: '2px' }}>
                        {change}
                    </div>
                ))}
            </div>
        </div>
    );
    
    return (
        <div sx={{ flexGrow: 1 }}>
            <AppBar position="static">
            <Toolbar>
                <WelcomeName />
                <SignInSignOutButton />
                
                {/* Version number with tooltip - positioned at the right */}
                <Tooltip 
                    title={tooltipContent}
                    placement="bottom-end"
                    arrow
                    enterDelay={500}
                    leaveDelay={200}
                >
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            marginLeft: 'auto', 
                            marginRight: 2,
                            opacity: 0.7,
                            fontSize: '0.75rem',
                            cursor: 'pointer',
                            '&:hover': {
                                opacity: 1,
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {versionInfo.version}
                    </Typography>
                </Tooltip>

                {/* Home button - rechts, na versie */}
                {location.pathname !== '/' && <HomeButton />}
                
            </Toolbar>
            </AppBar>
        </div>
    );
};

export default NavBar;